import React from 'react';
import { motion } from 'framer-motion';
type OrganicDividerProps = {
  variant?: 'wave' | 'curve' | 'gentle';
  flip?: boolean;
  className?: string;
  fillColor?: string;
};
export function OrganicDivider({
  variant = 'wave',
  flip = false,
  className = '',
  fillColor = 'fill-cream'
}: OrganicDividerProps) {
  const paths = {
    wave: 'M0,64 C120,100 240,20 360,64 C480,108 600,28 720,64 C840,100 960,20 1080,64 C1200,108 1320,28 1440,64 L1440,0 L0,0 Z',
    curve: 'M0,96 C360,150 720,0 1080,50 C1260,75 1380,30 1440,40 L1440,0 L0,0 Z',
    gentle: 'M0,40 C240,80 480,20 720,50 C960,80 1200,30 1440,60 L1440,0 L0,0 Z'
  };
  return <div className={`w-full overflow-hidden leading-none ${flip ? 'rotate-180' : ''} ${className}`} aria-hidden="true" data-id="element-170">
      <motion.svg initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} transition={{
      duration: 0.8
    }} viewport={{
      once: true
    }} className="relative block w-full h-16 md:h-24" viewBox="0 0 1440 100" preserveAspectRatio="none" data-id="element-171">
        <path d={paths[variant]} className={fillColor} data-id="element-172" />
      </motion.svg>
    </div>;
}